import * as Msal from 'msal';
import * as actions from "../actions/utility-actions";
import { IApplicationState } from '../store/IApplicationState';
import { authenticatedApiCall } from '../utils/api';
import { AppSettings } from "../utils/app-settings";

export const fetchMiddleware = (store: any) => (next: any) => (action: any) => {

    if (action.type === actions.FETCH) {

        const s = store.getState() as IApplicationState;
        let sc = '';
        if (s && s.userdata && s.userdata.activeServiceCenter) {
            sc = s.userdata.activeServiceCenter.name;
        }

        const parameters = parseFetchData(store, action);
        return authenticatedApiCall(parameters.url, parameters.data, parameters.type, sc);   
    }
    else if (action.type === actions.FETCH_AUTOCOMPLETE) {

        let sc = '';

        // Use the default behavior of the users active service center
        // but provide a means to override it
        if (action.serviceCenter && action.serviceCenter.length > 0) {
            sc = action.serviceCenter;
        }
        else {
            const s = store.getState() as IApplicationState;
            if (s && s.userdata && s.userdata.activeServiceCenter) {
                sc = s.userdata.activeServiceCenter.name;
            }
        }
        
        const parameters = parseFetchData(store, action);
        return authenticatedApiCall(parameters.url, parameters.data, parameters.type, sc);   
    }
    else if (action.type === actions.FETCH_BLOB) {

        const s = store.getState() as IApplicationState;
        let sc = '';
        if (s && s.userdata && s.userdata.activeServiceCenter) {
            sc = s.userdata.activeServiceCenter.name;
        }

        const parameters = parseFetchData(store, action);
        
        let postData : any;
        if (parameters.type === 'POST') {
            postData = action.data;
        }

        const request = {
            scopes: [AppSettings._adScope]
        } as Msal.AuthenticationParameters;

        const msal = window.msal as Msal.UserAgentApplication;
        return msal.acquireTokenSilent(request).then((response : Msal.AuthResponse) => { 

            //default
            var contentType = 'application/json';

            if (parameters.contentType) {
                contentType = parameters.contentType;
            }

            var bodyContent: any
            if (contentType === 'multipart/form-data') {
                bodyContent = postData;
            }
            else {
                bodyContent = JSON.stringify(postData);
            }

            var headers: any = {
                'Authorization': `Bearer ${response.accessToken}`,                
                'X-CHI-SERVICECENTER': sc
            };

            if (contentType === 'application/json') {
                headers['Content-Type'] = contentType;
            }

            return fetch(parameters.url, {
                    credentials: 'same-origin',
                    headers: headers,
                    body: bodyContent,
                    method: parameters.type,
                    mode: 'cors',
                    redirect: 'follow',
                    referrer: 'no-referrer',
                })
                .then((response) => {
                    if (response && response.status === 200) {
                        return response.blob();
                    }
                    else if (response && response.status >= 400 && response.status < 500) {
                        return response.json().then((data) => {
                            throw data;
                        });
                    }
                    else {
                        throw { 
                            errorCode: response.status, 
                            message: response.statusText
                        };
                    }
                })
                .catch((err) => {
                    throw err;
                });
        });

    }
    else {
        return next(action);
    }
};

/**
 * Pull of the necessary fetch properties into a simple object
 * @param store The redux store
 * @param action The action dispatched
 */
const parseFetchData = (store: any, action: any) => {

    const apiBase       = AppSettings._apiHost;
    const mediatorBase  = AppSettings._mediatorHost;

    const { url, methodType, contentType, params, location } = action;

    let requestUrl = '';
    if (location && location.length > 0 && location === 'mediator') {
        requestUrl = `${mediatorBase}${url}`;
    }
    else {
        requestUrl = `${apiBase}${url}`;
    }

    return {
        type: methodType ? methodType : 'GET',
        url: requestUrl,
        contentType: contentType,
        data: params ? params : null
    };
};
